// Light, dark, or follow the OS. The choice lives in a cookie so the server can
// render the right class on <html> (layouts/inertia.html.erb); that layout's
// head script resolves "system" and keeps following the OS while it's chosen.
export type Appearance = "system" | "light" | "dark";

export function currentAppearance(): Appearance {
  const value = document.documentElement.dataset.appearance;
  return value === "light" || value === "dark" ? value : "system";
}

export function setAppearance(appearance: Appearance) {
  const root = document.documentElement;
  root.dataset.appearance = appearance;
  const dark =
    appearance === "dark" ||
    (appearance === "system" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);
  root.classList.toggle("dark", dark);
  root.classList.toggle("light", !dark);
  document.cookie = `appearance=${appearance}; path=/; max-age=31536000; samesite=lax`;
}
